import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var ListHeaderFilter = function (_a) {
    var children = _a.children, isVersion2 = _a.isVersion2, rest = __rest(_a, ["children", "isVersion2"]);
    return (React.createElement("div", { className: 'top-of-lists-wrapper' },
        React.createElement("div", __assign({ className: "lists-title-filter-row ".concat(isVersion2 ? 'v-2' : '') }, rest), children)));
};

export { ListHeaderFilter };
